import './LegendContainer.scss';

export default ({ children }) => {
  return <legend className="legendContainer">{children}</legend>;
};
